import { UnitsPage } from "../views/ConfigSync/UnitsPage";

import LocalShippingIcon from "@material-ui/icons/LocalShipping";

export const unitsRoutes = [
  {
    collapse: true,
    name: "Unidades",
    icon: LocalShippingIcon,
    state: "pageUnitsSection",
    inSidebar: true,
    isProtected: true,
    rule: "UNITS",
    views: [
      {
        path: "/unidades_menu",
        name: "Unidades Soporte",
        mini: "UP",
        component: UnitsPage,
        // component: UnitsSectionPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "UNITS",
      },
    ],
  },
]
